import { Box, Divider } from "@mui/material";
import { Fragment } from "react";

export function PositionInfo(){
    return(
        <Fragment>
            <Box sx={{fontSize: "13px", fontWeight: "600"}}>Position parameters</Box>
            <Divider sx={{ paddingTop: "5px", borderColor: '#f2f3f3' }}/>
            <Box sx={{fontSize: "13px"}}>Not implemented...</Box>
        </Fragment>
    );
}